import React from 'react';
import { SxProps, Theme } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { LoadDirection } from '@paragon/contract-library';
import { Option } from '@paragon/layout-models';

type LoadDirectionOptions = {
  [key in LoadDirection]: Option<LoadDirection>;
};
const loadDirectionOptions: LoadDirectionOptions = {
  GlobalUp: {
    name: 'Up',
    value: 'GlobalUp',
  },
  GlobalDown: {
    name: 'Down',
    value: 'GlobalDown',
  },
  GlobalLeft: {
    name: 'Left',
    value: 'GlobalLeft',
  },
  GlobalRight: {
    name: 'Right',
    value: 'GlobalRight',
  },
  NormalUp: {
    name: 'Normal Up',
    value: 'NormalUp',
  },
  NormalDown: {
    name: 'Normal Down',
    value: 'NormalDown',
  },
  ParallelLeft: {
    name: 'Parallel Left',
    value: 'ParallelLeft',
  },
  ParallelRight: {
    name: 'Parallel Right',
    value: 'ParallelRight',
  },
};

interface LoadDirectionSelectProps {
  loadDirection: LoadDirection | null;
  submit: (loadDirection: LoadDirection) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function LoadDirectionSelect(props: LoadDirectionSelectProps) {
  const { disabled, loadDirection, sx, submit } = props;
  return (
    <PropertySelectField
      sx={sx}
      property="Direction"
      value={loadDirection ? loadDirectionOptions[loadDirection] : null}
      options={Object.values(loadDirectionOptions).filter(
        (loadDirectionOption) =>
          loadDirectionOption.value !== 'ParallelLeft' && loadDirectionOption.value !== 'ParallelRight',
      )}
      getName={(option) => option.name}
      getValue={(option) => option.value}
      submit={(loadDirectionOption) => void submit(loadDirectionOption.value)}
      disabled={disabled}
    />
  );
}
